export default __webpack_public_path__ + "static/media/04.c930db74.png";